import FakeSearch from './FakeSearch';

export default FakeSearch;
